import { createContext, useContext, useEffect, useState } from "react";
import { setA11yMode } from "@/lib/smoothScroll";

const AccessibilityContext = createContext(null);

const STORAGE_KEY = "gb-a11y";

export function AccessibilityProvider({ children }) {
  const [a11y, setA11y] = useState(() => localStorage.getItem(STORAGE_KEY) === "1");

  useEffect(() => {
    document.documentElement.classList.toggle("a11y", a11y);
    localStorage.setItem(STORAGE_KEY, a11y ? "1" : "0");
    setA11yMode(a11y);
  }, [a11y]);

  const toggle = () => setA11y((v) => !v);

  return (
    <AccessibilityContext.Provider value={{ a11y, toggle }}>
      {children}
    </AccessibilityContext.Provider>
  );
}

export const useA11y = () => useContext(AccessibilityContext);
